import { ACTION_TYPE } from '../actions/actionTypes';

const { CATALOGUE } = ACTION_TYPE;

const catalogueReducer = (state = {}, action) => {
  switch (action.type) {
    case CATALOGUE.FETCH_SCREENER:
      return {
        ...state,
        data: action.payload,
      };
    case CATALOGUE.SELECTED_PRODUCT:
      return {
        ...state,
        selected: action.payload,
      };
    default:
      return state;
  }
};

export default catalogueReducer;
